import Portfolio1Pic1 from "../../assets/portfolio/ss-pr-1.png";
import Portfolio1Pic2 from "../../assets/portfolio/ss-pr-2.png";
import Portfolio2Pic1 from "../../assets/portfolio/ss-pr-3.jpg";
import Portfolio2Pic2 from "../../assets/portfolio/ss-pr-4.png";
import Portfolio3Pic1 from "../../assets/portfolio/ss-pr-5.png";
import Portfolio4Pic1 from "../../assets/portfolio/ss-pr-6.png";
import Portfolio4Pic2 from "../../assets/portfolio/ss-pr-7.png";
import Portfolio5Pic1 from "../../assets/portfolio/ss-pr-8.png";
import Portfolio5Pic2 from "../../assets/portfolio/ss-pr-9.png";
import Portfolio6Pic1 from "../../assets/portfolio/ss-pr-10.png";
import Portfolio6Pic2 from "../../assets/portfolio/ss-pr-11.png";
import Work5 from '../../assets/work-1.svg';
import Work6 from '../../assets/work-1.svg';

const Menu = [
  {
    id: 1,
    images: [Portfolio1Pic1, Portfolio1Pic2],
    title: "Novatix Website Class",
    client: "23th Multimedia and Network Engineer",
    category: "Programming",
  },
  {
    id: 2,
    images: [Portfolio2Pic1, Portfolio2Pic2],
    title: "Graphics Designer",
    client: "HIMATIK PNUP",
    category: "Design",
  },  
  {
    id: 3,
    images: [Portfolio3Pic1],
    title: "Telegram Bot Assistant",
    client: "Mr. Eko",
    category: "Programming",
  },
  {
    id: 4,
    images: [Portfolio4Pic1, Portfolio4Pic2],
    title: "3D Ads Animation",
    client: "3th Semester's Mid Project",
    category: "Design",
  },
  {
    id: 5,
    images: [Portfolio5Pic1, Portfolio5Pic2],
    title: "Recycle Website System",
    client: "Jakstrada Makassar",
    category: "Programming",
  },
  {
    id: 6,
    images: [Portfolio6Pic1, Portfolio6Pic2],
    title: "Virtual Set News",
    client: "3th Semester's Final Project ",
    category: "Design",
  },
];

export default Menu;